import React from 'react';
import LegacyForm from './LegacyForm';
import Version2025 from './Version2025';

function KansasForm(props) {
  const { version } = props;
  const isVersion2025OrLater = ['7_24'].includes(version);

  if (isVersion2025OrLater) return <Version2025 {...props} />;

  return <LegacyForm {...props} />;
}

export default KansasForm;
